import lodash from "lodash";
import { getAction, listAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";
import { File } from "../classes/file.class";
import { Product } from "../classes/product.class";
/**
 * Gets a center entry.
 */
export const getProductEntry = function(value, slugOrId, recursive)
{
	return getAction("products", value, slugOrId, recursive).then(data => {
		if (data.data[0])
			return processEntry(data.data[0]);
		if (data.data)
			return processEntry(data.data);
	});
}

/**
 * Gets a list of centers.
 */
export const getProductsList = function(recursive, page)
{
	return listAction("products", recursive, page).then(data => {
		return { content: processList(data.data), totalProducts: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
}

/**
 * Process Entry.
 */
const processEntry = function(data)
{
	let content = data;
	content = new Product(content)

	if (content.image && data.related_ids[content.image])
		content.image = new Image(data.related_ids[content.image]);
	
	if (content.pdf && data.related_ids[content.pdf])
		content.pdf = new File(data.related_ids[content.pdf]);
	
	if (content.gallery) {
		content.gallery = content.gallery.map(image => {
			return new Image(data.related_ids[image]);
		});
	}
	return content;
}

/**
 * Process List.
 */
const processList = function(data)
{
	let content = data;
	
	content = content.map( value => {
		return processEntry(value)
	})

	return content;
}


// WEBPACK FOOTER //
// ./src/data/models/product.model.js